import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { browserHistory } from 'react-router';
import lodashGet from 'lodash/get';
import FooterButtons from '@components/Button/FooterButtons';
import DropdownInput from '@components/DropdownInput';
import Coupon from '@components/Coupon';
import * as actions from '../../actions';
import * as Constants from '../../constants';
import './CustomerInfo.scss';
import * as Validations from '../../utils/validations';
import SecondaryButton from '../../components/Button/SecondaryButton';
import approved from '../../images/approved.svg';
import denied from '../../images/error.svg';
import ResendTimer from './ResendTimer';
import { sendToGTM } from '../../utils/gtmHelper';
import InView from '../../utils/InView';
import { getServiceByType } from '../../constants/services';
import MoveRight from '../../images/move-right.png';

const initialState = {
  mobileNumber: '',
  name: '',
  nameError: '',
  showMobileError: '',
  pincodeError: '',
  pincodeText: '',
  customerInput: '',
  diagnosticsAvailable: false,
  isPincodeServiceableDiag: false,
  isPincodeServiceabilityLoading: false,
  diagnosticsAvailabliltyLoading: false,
  selectedNeighbourhood: {},
  showCustomerNameError: false,
  isMobileNumberFreezed: false,
  isOTPFeatureEnabled: false,
  otp: '',
  isValidOTP: false,
  OTPMessage: null,
  showResendTimer: true,
  isMobileNumberBlocked: false,
  isDifferentNumber: false,
  alreadyVisitedCustomerInfoPage: false,
  hasGivenOTPInput: false,
  showServicesDropup: false,
};

class CustomerInfo extends Component {

  constructor(props) {
    super(props);
    this.state = initialState;
  }

  componentWillMount() {
    const alreadyVisitedCustomerInfoPage = this.props.location.state && this.props.location.state.alreadyVisitedCustomerInfoPage;
    this.focusOnRelevantFields();
    this.props.actions.changeHeaderState(Constants.CUSTOMER_INFO);
    const customerDetails = this.props.customer.customerDetails.data;
    const pincode = lodashGet(customerDetails, 'addresses.0.pincode');
    const { mobileNumber, diagnosticLeadId } = this.props.location.query;
    if (diagnosticLeadId) {
      this.props.actions.setLeadCx(diagnosticLeadId);
    }
    this.setSalesForceId();
    const customerContact = mobileNumber || (customerDetails && customerDetails.profile && customerDetails.profile.mobileNumber)
    if (customerContact && alreadyVisitedCustomerInfoPage) {
      this.customerSearch(customerContact);
    }
    this.setState({
      mobileNumber: customerContact,
      isOTPFeatureEnabled: this.props.user.data.features.otp.isEnabled || false,
      isOTPVerificationMandatory: this.props.user.data.features.otp.isMandatory || false,
      selectedNeighbourhood: { value: pincode, label: pincode },
      name: customerDetails && customerDetails.profile && customerDetails.profile.name,
      alreadyVisitedCustomerInfoPage: alreadyVisitedCustomerInfoPage || false,
    });
  }

  setSalesForceId = () => {
    const params = new URLSearchParams(window.location.search)
    const salesforceLeadId = params.get('salesforceLeadId')
    this.props.actions.setSalesForceLeadId(salesforceLeadId)
  }

  componentDidMount() {
    window.sessionStorage.setItem("isCSCUser", this.props.user.data.isCSCUser);
    this.focusOnRelevantFields();
  }

  componentWillReceiveProps(newProps) {
    const pathname = window.location.pathname;
    const type = newProps.customer.action && newProps.customer.action.type;
    const oldType = this.props.customer.action && this.props.customer.action.type;
    const globalAction = newProps.action;
    switch (globalAction.type) {
      case Constants.CLOSE_THIS_TASK:
        this.cancelOrder();
        break;
      case Constants.MEDICINE_SEARCH:
        this.focusOnRelevantFields();
        break;
      case Constants.MOVE_BACKWARD:
        globalAction.path == pathname && this.cancelOrder();
        break;
      default:
        break;
    }
    if (type === oldType) {
      return;
    }
  }

  setName(customerInput) {
    this.setState({ customerInput: customerInput });
  }

  setNumber = number => {
    const valid = Validations.mobile(number);
    this.setState({ mobileNumber: number, showMobileError: !valid ? 'Must be a 10 digit number' : '' });
    if (valid) {
      this.props.actions.setLeadCx('');
    }
  }

  setOTP = otp => {
    const valid = Validations.otp(otp);
    this.setState({ otp: otp });
    if (!valid) {
      this.setState({ isValidOTP: false });
    }
  }

  isDiagnosticsAvailable = pincode => {
    this.setState({
      diagnosticsAvailabliltyLoading: true,
    });
    this.props.actions.fetchDiagnosticsAvailability(pincode).then(result => {
      this.setState({
        diagnosticsAvailable: lodashGet(result.data, 'cityAttributes.isPathlab', false),
      });
    }).finally(() => {
      this.setState({
        diagnosticsAvailabliltyLoading: false,
      });
    });
    this.isPincodeServiceable([pincode]);
  }

  isPincodeServiceable = pincodes => {
    this.setState({
      isPincodeServiceabilityLoading: true,
    });

    this.props.actions.fetchPincodeServiceability({ pincodes }).then(response => {
      if (response && response.status === 1) {
        const isServiceable = (response.data && response.data.length > 0) ? response.data[0].is_serviceable : false;
        this.setState({
          isPincodeServiceableDiag: isServiceable,
        });
      } else {
        this.setState({
          isPincodeServiceableDiag: false,
        });
      }
    }).catch(() => {
      this.setState({
        isPincodeServiceableDiag: false,
      });
    }).finally(() => {
      this.setState({
        isPincodeServiceabilityLoading: false,
      });
    });
  }

  focusOnRelevantFields() {
    return !this.state.mobileNumber && this.nameInput && this.nameInput.focus();
  }
  reset() {
    this.setState(initialState);
  }

  saveCustomerInfo = async () => {
    const { id: customerId, name: customerName } = this.props.customer.customerDetails.data.profile;
    if ((this.state.customerInput != customerName) && this.state.customerInput) {
      this.props.actions.customerProfileUpdate({
        name: this.state.customerInput,
        id: customerId
      });
      return true;
    } else if (!this.state.customerInput) {
      this.setState({
        showCustomerNameError: true
      });
      return false;
    }
    return true;
  }

  startTakingOrder = async (orderType) => {
    const customerInfoSaved = await this.saveCustomerInfo();
    if (!customerInfoSaved) {
      return;
    }
    switch (orderType) {
      case Constants.ORDER_TYPE_DIAGNOSTIC:
        const pincode = this.state.selectedNeighbourhood.value;
        this.props.actions.setCustomerPincode(pincode);
        this.props.actions.setOrderType(1);
        browserHistory.push('/diagnostics/add-products');
        return;
      case Constants.ORDER_TYPE_MEDICINE:
        this.props.actions.setOrderType(0);
        this.isPincodeDeliverable();
        return;
      case Constants.ORDER_TYPE_DOC_CONSULT:
        this.props.actions.setOrderType(2);
        browserHistory.push('/doc-consult/select-speciality');
        return;
    }
  }

  toggleServicesDropup = () => {
    this.setState({ showServicesDropup: !this.state.showServicesDropup });
  };

  selectService = (serviceType) => {
    this.setState({ showServicesDropup: false });

    if (serviceType === 'doctor-consultation') {
      this.startTakingOrder(Constants.ORDER_TYPE_DOC_CONSULT);
    } else {
      // Generic service-platform routing
      const service = getServiceByType(serviceType);
      if (service) {
        this.props.actions.setOrderType(3);
        browserHistory.push(`/services/${service.routePrefix}/select-package`);
      } else {
        alert(`${serviceType} coming soon`);
      }
    }
  };

  cancelOrder() {
    if (confirm('Are you sure you want to cancel this order ?')) {
      this.reset();
      this.setState({
        isOTPFeatureEnabled: this.props.user.data.features.otp.isEnabled || false,
        isOTPVerificationMandatory: this.props.user.data.features.otp.isMandatory || false,
      })
      this.props.actions.setLeadCx('');
      this.props.actions.cancelOrder();
      browserHistory.push('/customer-info');
      this.focusOnRelevantFields();
    }
  }

  isPincodeDeliverable = () => {
    const pincode = this.state.selectedNeighbourhood.value;
    if (Validations.pincode(pincode)) {
      this.setState({ pincodeError: '' });
      this.props.actions.isPincodeDeliverable({ pincode }).then(() => {
        this.props.actions.setCustomerPincode(pincode);
        this.props.actions.fetchActiveRefills({ type: 'active' });
        this.props.actions.fetchDeliveredMedicines();
        this.focusOnRelevantFields();
        browserHistory.push('/add-products');
      });
    } else {
      this.setState({ pincodeError: 'Please Enter Valid Pincode' });
    }
  }

  sendNumberChoiceSelectionEvent(isDifferentNumber) {
    sendToGTM({
      eventLabel: Constants.MAKE_OTP_SEND_CHOICE,
      eventDetails: {
        otp_required: isDifferentNumber,
        element_name: isDifferentNumber ? 'different_number' : 'same_number',
        destination: isDifferentNumber ? Constants.OTP_INPUT_LOAD : '',
        ...this.commonEventPayload(),
      }
    });
  }

  commonEventPayload() {
    const user = this.props.user.data;
    return {
      agent_email: user.userEmail,
      agent_role: user.userRole,
      is_otp_feature_enabled: user.features.otp.isEnabled,
      is_otp_mandatory: user.features.otp.isMandatory,
    }
  }

  handleDifferentNumber = () => {
    this.setState({
      showMobileError: '',
      isOTPFeatureEnabled: true,
      isMobileNumberFreezed: true,
      isDifferentNumber: true,
    }, () => {
      this.sendNumberChoiceSelectionEvent(true);
    });
    this.sendOTP();
  }

  customerSearch = (mobileNumber) => {
    if (Validations.mobile(mobileNumber)) {
      this.sendNumberChoiceSelectionEvent(false);
      this.setState({ showMobileError: '', isMobileNumberFreezed: true, isOTPFeatureEnabled: false });
      const params = {
        contactNumber: mobileNumber,
        skipOTPVerification: true,
      }

      this.props.actions.customerSearch(params).then((response) => {
        this.setCustomerDetails(response);
      });
    } else {
      this.setState({ showMobileError: 'Please Enter Valid Mobile Number' });
    }
  }

  setCustomerDetails = (response) => {
    if (response.status === 1) {
      this.setState({
        customerInput: response.data.profile.name,
        isValidOTP: true,
      });
      const pincode = lodashGet(response.data.addresses, '0.pincode');
      if (pincode) {
        this.setState({
          selectedNeighbourhood: { value: pincode, label: pincode },
          pincodeText: `Last used pincode: ${pincode}`
        });
        this.isDiagnosticsAvailable(pincode);
      }
    }
    if (response.status === 0) {
      this.setState({ showMobileError: response.error.message });
    }
  }

  sendOTPStatusEvent(status) {
    sendToGTM({
      eventLabel: Constants.OTP_STATUS,
      eventDetails: {
        status: status,
        otp_message: this.state.OTPMessage,
        ...this.commonEventPayload(),
      }
    })
  }

  validateOTP = (response) => {
    if (response.status === 1) {
      this.setState({ isValidOTP: true, OTPMessage: 'Approved' }, () => {
        this.sendOTPStatusEvent('approved');
      });
      this.setCustomerDetails(response);
    } else {

      this.setState({
        isValidOTP: false,
        OTPMessage: response.error.message,
        showResendTimer: true,
      }, () => {
        this.sendOTPStatusEvent('rejected');
      })
    }
  }

  verifyOTP = () => {
    this.setState({ hasGivenOTPInput: true });
    if (Validations.otp(this.state.otp)) {
      this.props.actions.customerSearch({
        contactNumber: this.state.mobileNumber,
        userOtp: this.state.otp,
        skipOTPVerification: false,
      }).then((response) => {
        return this.validateOTP(response);
      });
    } else {
      this.setState({ isValidOTP: false, OTPMessage: 'Please Enter a valid OTP' });
    }
  }

  sendOTP = () => {
    this.setState({ isOTPFeatureEnabled: true, showResendTimer: false }, () => {
      this.props.actions.sendOTP(this.state.mobileNumber).then((response) => {
        if (response.status === 0) {
          if (response.error.message == 'You can not request any more OTP today.') {
            this.setState({ showResendTimer: false, OTPMessage: response.error.message });
          }
          this.setState({ OTPMessage: response.error.message });
          this.sendOTPStatusEvent('send failed');
          return;
        }
        this.sendOTPStatusEvent('sent');
      });
      this.setState({ showResendTimer: true });
    });
  }

  handleNeighbourhoodSearch = (input) => {
    if (!input) {
      return;
    }
    return this.props.actions.searchNeighbourhood({
      q: input,
    }).then(result => {
      const neighbourhoodData = result.data || [];
      return neighbourhoodData.map(({ pincode, text }) => ({ value: pincode, label: text }));
    });
  }

  handleNeighbourhoodSelect = selectedNeighbourhood => {
    this.setState({ selectedNeighbourhood });
    this.isDiagnosticsAvailable(selectedNeighbourhood.value);
  }

  handleMobileNumberClick() {
    if (!Validations.mobile(this.state.mobileNumber)) {
      this.setState({ showMobileError: 'Please enter a valid Mobile Number' });
      return;
    }
    if (this.state.isOTPVerificationMandatory) {
      this.setState({ isMobileNumberFreezed: true });
      this.sendOTP();
    } else if (!this.state.isOTPFeatureEnabled) {
      this.props.actions.customerSearch({
        contactNumber: this.state.mobileNumber,
      }).then((response) => {
        this.setState({ isMobileNumberFreezed: true });
        this.setCustomerDetails(response);
      });
    }
  }

  showOTPButtonPanel() {
    const { customerDetails } = this.props.customer;
    const {
      isOTPFeatureEnabled,
      mobileNumber,
      isMobileNumberFreezed,
      isOTPVerificationMandatory
    } = this.state;

    return !customerDetails.data && isOTPFeatureEnabled && Validations.mobile(mobileNumber) && !isMobileNumberFreezed && !isOTPVerificationMandatory;
  }

  sendEvent(eventName) {
    sendToGTM({
      eventLabel: eventName,
      eventDetails: {
        ...this.commonEventPayload()
      }
    })
  }

  handleResendClick() {
    this.setState({ hasGivenOTPInput: false, OTPMessage: null })
    this.sendOTP();
    this.sendEvent(Constants.RESEND_OTP_CLICK);
  }

  handleOTPInputInView = (intersection) => {
    const { inView } = intersection;
    if (inView) {
      this.sendEvent(Constants.OTP_INPUT_LOAD);
    }
  }

  getCustomerType = isOldUser => {
    if (typeof isOldUser === 'boolean') {
      return isOldUser ? 'old' : 'new';
    }
    return 'NA';
  };

  getClassNameBasedOnUserType = userType => {
    switch (userType) {
      case 'new':
        return 'CustomerNew';
      case 'old':
        return 'CustomerOld';
      default:
        return 'CustomerUnknown';
    }
  };

  customerTagUI = customerTypeObj => (
    <div className="customerTypeWrapper">
      {customerTypeObj.map(vertical => (
        <div className="customerTypeRow" key={vertical.key}>
          <div className="verticalType">{vertical.key}</div>
          <div
            className={`CustomerType ${this.getClassNameBasedOnUserType(
              vertical.userType
            )}`}
          >
            {vertical.userType}
          </div>
        </div>
      ))}
    </div>
  );

  renderCustomerTag = customerProfileData => {
    const {
      hasCompletedDiagnosticOrder: isOldDiagnosticsUser,
      hasDeliveredOrder: isOldMedicineUser,
    } = customerProfileData || {};

    const customerTypeObj = [
      {
        key: 'medicine',
        userType: this.getCustomerType(isOldMedicineUser),
      },
      {
        key: 'diagnostics',
        userType: this.getCustomerType(isOldDiagnosticsUser),
      },
    ];

    return this.customerTagUI(customerTypeObj);
  };

  renderServicesDropup = () => (
    <div>
      <div
        className="servicesDropupOverlay"
        onClick={this.toggleServicesDropup}
      />
      <div className="servicesDropup">
        <div
          className="serviceOption"
          onClick={() => this.selectService('doctor-consultation')}
        >
          Doctor Consultation
          <img src={MoveRight} />
        </div>
        <div
          className="serviceOption"
          onClick={() => this.selectService('weight-management')}
        >
          Weight Loss Management
          <img src={MoveRight} />
        </div>
        <div
          className="serviceOption"
          onClick={() => this.selectService('physiotherapy')}
        >
          Physiotheraphy
          <img src={MoveRight} />
        </div>
      </div>
    </div>
  );

  render() {
    const { customerDetails, location, loading } = this.props.customer;
    const {
      mobileNumber,
      showMobileError,
      pincodeError,
      pincodeText,
      selectedNeighbourhood,
      showCustomerNameError,
      isOTPFeatureEnabled,
      isMobileNumberFreezed,
      otp,
      showResendTimer,
      isValidOTP,
      OTPMessage,
      isMobileNumberBlocked,
      isDifferentNumber,
      alreadyVisitedCustomerInfoPage,
      hasGivenOTPInput,
      diagnosticsAvailabliltyLoading,
      isPincodeServiceableDiag,
      isPincodeServiceabilityLoading,
    } = this.state;
    const nextStateAllowed = !!selectedNeighbourhood.value;
    const isDiagFlowAllowed = isPincodeServiceableDiag && !diagnosticsAvailabliltyLoading && !isPincodeServiceabilityLoading;
    const customerProfileData = customerDetails && customerDetails.data && customerDetails.data.profile;

    return (
      <div className="CustomerInfoContainer">
        <div className="customerInfoWrapper">
          <div className="CustomerInfoHeader">Customer Information</div>
          {customerProfileData && (this.renderCustomerTag(customerProfileData))}
        </div>
        <div className="CustomerDetailRow">
          <div className="CustomerDetailsHeader">Mobile Number {isMobileNumberFreezed ? '(order will be placed on this number)' : ''}</div>
          <div className="CustomerMobileContainer">
            <input
              type="text"
              pattern="[16789][0-9]{9}"
              minLength={10}
              maxLength={10}
              ref={input => { this.nameInput = input; }}
              className="CustomerInput"
              value={mobileNumber}
              readOnly={isMobileNumberFreezed}
              placeholder="Please enter customer's mobile number"
              onKeyPress={e => e.which == 13 ? this.handleMobileNumberClick() : true}
              onChange={event => this.setNumber(event.target.value)}
              onBlur={event => this.setNumber(event.target.value)}
            />
            {(customerDetails.data && nextStateAllowed) && <Coupon />}
          </div>
          {showMobileError !== '' && <div className="errorMsg">{showMobileError}</div>}
          {isMobileNumberFreezed && <div className="disclaimerMsg">Customer is calling from {isDifferentNumber ? 'another' : 'same'} number</div>}
        </div>
        {this.showOTPButtonPanel() && <div className="CTABtn">
          {
            <div className="otpButtonPanel">
              <p className="infoText">Customer is calling from</p>
              <SecondaryButton
                text='Same Number'
                subText='No OTP required'
                loading={loading}
                onClickFunction={() => this.customerSearch(mobileNumber)}
              />
              <SecondaryButton
                text='Different Number'
                subText='OTP required'
                loading={loading}
                float='right'
                onClickFunction={() => this.handleDifferentNumber()}
              />
            </div>
          }
        </div>}
        {isOTPFeatureEnabled && isMobileNumberFreezed && !alreadyVisitedCustomerInfoPage &&
          <InView onChange={(intersection) => this.handleOTPInputInView(intersection)}>
            < div >
              <p className="infoText">Enter the OTP received by customer on the above number for verification</p>
              <input
                type="text"
                minLength={4}
                maxLength={4}
                ref={input => { this.otp = input; }}
                className={`CustomerInput ${hasGivenOTPInput ? (isValidOTP ? 'success-border' : 'failure-border') : ''}`}
                value={otp}
                placeholder="Please enter OTP"
                onKeyPress={e => (e.which == 13) ? this.verifyOTP() : true}
                onChange={event => this.setOTP(event.target.value)}
                onBlur={event => this.setOTP(event.target.value)}
              />
              {OTPMessage &&
                <div className="otpMessage">
                  <img className="otpMessageIcon" src={isValidOTP ? approved : denied}></img>
                  <div className={isValidOTP ? 'success' : 'failure'}>{OTPMessage}</div>
                </div>
              }
              {
                showResendTimer && !isValidOTP && !isMobileNumberBlocked && <ResendTimer onClickFunction={() => this.handleResendClick()} />
              }
            </div>
          </InView>
        }
        {
          customerDetails.data && <div className="CustomerDetailRow">
            <div className="CustomerDetailsHeader">Customer Name</div>
            <input
              onChange={event => this.setName(event.target.value)}
              type="text"
              className="CustomerInput"
              ref={input => { this.customerName = input; }}
              placeholder="Please enter the customer name"
              value={this.state.customerInput}
              autoComplete="off"
            />
            {showCustomerNameError && <div className="errorMsg">Customer name is required</div>}
          </div>
        }
        {
          customerDetails.data && <div className="CustomerLocationContainer">
            <div className="CustomerDetailRow">
              <div className="CustomerDetailsHeader">Pincode</div>
              <DropdownInput
                loadOptions={this.handleNeighbourhoodSearch}
                onSelect={this.handleNeighbourhoodSelect}
                placeholder="Enter Pincode/Neighbourhood"
                value={selectedNeighbourhood}
                className="NeighbourhoodInput"
                emptyText="No deliverable neighbourhood found."
              />
              <div style={{ fontSize: '13px', color: '#14151a' }}>
                {pincodeText.length > 0 ? `[${pincodeText}]` : ''}
              </div>
            </div>
            {pincodeError !== '' && <div className="errorMsg">{pincodeError}</div>}
            {location && location.status == 0 && <div className="errorMsg">{location.error.message}</div>}
            {!isPincodeServiceableDiag && selectedNeighbourhood.value && !isPincodeServiceabilityLoading && <div className="errorMsg">Diagnostic services unavailable at this pincode</div>}
            {(diagnosticsAvailabliltyLoading || isPincodeServiceabilityLoading) && <strong>Loading Please Wait...</strong>}
          </div>
        }
        {
          (isMobileNumberFreezed || customerDetails.data) && <FooterButtons
            proceedBtnClick={() => this.startTakingOrder(Constants.ORDER_TYPE_MEDICINE)}
            proceedBtnText={loading ? 'Loading...' : 'Medicine Order'}
            nextStateAllowed={nextStateAllowed}
            showDiagBtnEnabled={isDiagFlowAllowed}
            showDiagBtn
            diagBtnText={loading ? 'Loading...' : 'Diagnostic Order'}
            diagBtnClick={() => this.startTakingOrder(Constants.ORDER_TYPE_DIAGNOSTIC)}
            cancelBtnClick={() => this.cancelOrder()}
            cancelBtnText="Cancel Order"
            loading={loading}
            showServiceBtn={true}
            serviceButtonTxt={loading ? 'Loading...' : 'Services'}
            serviceBtnClick={this.toggleServicesDropup}
            showServicesDropup={this.state.showServicesDropup}
            servicesDropupContent={this.renderServicesDropup()}
          />
        }
      </div>
    );
  }
}

CustomerInfo.propTypes = {
  customer: PropTypes.object.isRequired,
  actions: PropTypes.object.isRequired,
  location: PropTypes.object.isRequired,
};

export default connect(state => ({
  customerDetails: state.customer.customerDetails,
  deliveredMedicines: state.customer.deliveredMedicines,
  deliveredOrders: state.customer.deliveredOrders,
  customer: state.customer,
  action: state.action,
  user: state.user
}), dispatch => ({
  actions: bindActionCreators(actions, dispatch)
}))(CustomerInfo);
